import React from 'react';
const rows = [{
  before: 'Intere serate a cercare esercizi su YouTube.',
  after: 'Sessioni pronte sul tuo smartphone in 2 clic.'
}, {
  before: 'Stress prima di ogni lezione per non sapere cosa insegnare.',
  after: 'Sicurezza totale entrando in studio.'
}, {
  before: 'Spiegazioni infinite che i tuoi allievi non capiscono.',
  after: 'Guide visive che si spiegano da sole.'
}, {
  before: 'Sensazione che i tuoi allievi siano bloccati.',
  after: "Progressione chiara dal principiante all'avanzato senza sforzo."
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-57">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-58">
            Pianificare in modo manuale ti toglie una media di{' '}
            <span className="text-badge-red font-black" data-id="element-59">
              2 a 4 ore per sessione
            </span>
            . Sono{' '}
            <span className="text-badge-red font-black" data-id="element-60">
              più di 100 ore all'anno perse.
            </span>
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-61">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-62">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-63">
              SENZA PILATES ELITE (Cosa ti costa oggi)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]" data-id="element-64">
              CON PILATES ELITE (La tua vita domani)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-65">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-66">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-67">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-68">
                    <span className="text-badge-red font-bold text-sm" data-id="element-69">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-70">{row.before}</p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-71">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-72"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-73">
                    <span className="text-check-green font-bold text-sm" data-id="element-74">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-bold relative z-10" data-id="element-75">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}